export const visit = (vm, at) => {
at({ "fr": { "purchaseMotions": { "pricingPageRedirect": { "button": { "defaultButtonCopy": "Afficher le prix" } } } } });
};